import * as mdc from 'material-components-web';
export class MaterialHelpers {
	public static setTextFieldHelperText(id:string, text:string, isError:boolean) {
		const dom = document.querySelector(`#${id}`);
		if (!dom) {
			console.warn(`cannot find element with id ${id}`);
			return;
		}
		if (!dom.classList.contains(`mdc-text-field`)) {
			console.warn(`missing material class "mdc-text-field" on element with id: ${id}`);
			return;
		}
		let textField: mdc.textField.MDCTextField = new mdc.textField.MDCTextField(dom);
		if (!textField) {
			console.warn("cannot initialise MDCTextField");
			return;
		}
		textField.valid = !isError;
		textField.useNativeValidation = false;
		textField.helperTextContent = text;
	}

	public static setTextFieldHelperTextWithHtmlContent(id:string, helperTextId:string, text:string, isError: boolean) {
		const dom = document.querySelector(`#${id}`);
		if (!dom) {
			console.warn(`cannot find element with id ${id}`);
			return;
		}
		if (!dom.classList.contains(`mdc-text-field`)) {
			console.warn(`missing material class "mdc-text-field" on element with id: ${id}`);
			return;
		}
		let textField: mdc.textField.MDCTextField = new mdc.textField.MDCTextField(dom);
		if (!textField) {
			console.warn("cannot initialise MDCTextField");
			return;
		}
		textField.valid = !isError;
		textField.useNativeValidation = false;
		textField.helperTextContent = text;

		//todo: expliziter helpertext kann raus weil das oben schon über das md-objekt gelöst wird
		let helper = document.getElementById(helperTextId);
		if(helper) {
			helper.innerHTML = text;
		}
	}

	public static removeTextFieldHelperText(id:string) {
		this.setTextFieldHelperText(id,'', false);
	}

	public static addEventListener(id:string, fn:Function, funcType:string) {
		if(id.isNullOrEmpty()){
			console.warn('MaterialHelpers addEventListener parameter id is empty');
		}
		if(!fn) {
			console.warn('MaterialHelpers addEventListener handler function is empty');
		}
		if(funcType.isNullOrEmpty()) {
			console.warn('MaterialHelpers addEventListener function type is empty');
		}

		let dom = document.querySelector(`#${id}`);
		if(dom) {
			try {
				let element = new mdc.textField.MDCTextField(dom);
				element.listen(funcType, fn);
			}catch (e) {
				console.error(e);
			}
		} else {
			console.warn(`couldn't find element '${id}'`);
		}
	}

	public static setTextFieldValue(id: string, value:string) {
		const dom = document.querySelector(`#${id}`);
		if(dom) {
			const field = new mdc.textField.MDCTextField(dom);
			let foundation = field.getDefaultFoundation();
			foundation.setValue(value);
		}
	}
}